<template>
  <ion-modal 
    :is-open="isOpen" 
    :initial-breakpoint="0.65" 
    :breakpoints="viewport.modalBreakpoints.value"
    @didDismiss="$emit('close')"
    :class="modalClass"
    :data-cy="dataCy"
  >
    <slot />

    <ion-buttons class="flex justify-center mt-0 pt-0">
      <ion-button @click="$emit('close')" data-cy="close-modal-button" fill="clear">
        <ion-icon :icon="chevronDownOutline" slot="icon-only" size="large"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-modal>
</template>

<script setup lang="ts">
import { IonModal, IonButtons, IonButton, IonIcon } from '@ionic/vue';
import { chevronDownOutline } from 'ionicons/icons';
import { useViewport } from '../composables/useViewport';

interface Props {
  isOpen: boolean;
  modalClass?: string;
  dataCy?: string;
}

defineProps<Props>();
defineEmits<{
  close: [];
}>();

// Use viewport composable instead of direct window access
const viewport = useViewport();
</script>

<style scoped>
ion-modal {
  --border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

ion-modal::-webkit-scrollbar {
  display: none;
}

/* Responsive modal adjustments */
@media (min-width: 768px) {
  ion-modal {
    --width: 400px;
    --height: 600px;
    --border-radius: var(--radius-lg);
  }
}
</style> 